// removed by extract-text-webpack-plugin
module.exports = {"icon":"ButtonInbox_icon--1ioSP","base__new-message":"ButtonInbox_base__new-message---ieDJ","baseNewMessage":"ButtonInbox_base__new-message---ieDJ","messages":"ButtonInbox_messages--18o6d"};


//////////////////
// WEBPACK FOOTER
// ./components/ButtonInbox/ButtonInbox.scss
// module id = 2311
// module chunks = 11